
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import principalutlvg from './pages/principalutlvg/principalutlvg'
import informacion7jb4a from './pages/informacion7jb4a/informacion7jb4a'
import quehacemos5ecyb from './pages/quehacemos5ecyb/quehacemos5ecyb'
import contactoj8kuwg from './pages/contactoj8kuwg/contactoj8kuwg'
import guiadigitalynxzv from './pages/guiadigitalynxzv/guiadigitalynxzv'
import error4045o606 from './pages/error4045o606/error4045o606'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={principalutlvg} />
			<Route exact path="/informacion" component={informacion7jb4a} />
			<Route exact path="/quehacemos" component={quehacemos5ecyb} />
			<Route exact path="/contacto" component={contactoj8kuwg} />
			<Route exact path="/guiadigital" component={guiadigitalynxzv} />
			<Route exact path="*" component={error4045o606} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

